import { useAppSelector } from '../store/store';
import useIsMobile from './useIsMobile';

// The edit-mode lock only exists to guard against accidental taps on a touchscreen
// carried around site - on desktop there's no such risk, so edit mode is implicitly
// always on there and the toggle itself stays hidden (see EditModeToggle).
const useEditModeEnabled = (): boolean => {
  const isMobile = useIsMobile();
  const isEnabled = useAppSelector((state) => state.edit_mode.isEnabled);

  return isMobile ? isEnabled : true;
};

export default useEditModeEnabled;
